import React from "react";

import { Typography } from "clearsense-ui/components";

import { FORMAT_REFERENCE } from "../../constants";

const SyntaxSpan = ({ content }) => (
  <span className="text-yellow-300">{content}</span>
);

const FormatReference = () => (
  <div className="p-4 max-w-lg overflow-scroll text-white bg-black rounded-md h-90">
    <SyntaxSpan content="{" />
    {Object.entries(FORMAT_REFERENCE).map(([key, value]) => (
      <div className="flex space-x-2 ml-4" key={key}>
        <Typography className="text-red-500">
          {`"${key}"`}
          <SyntaxSpan content=":" />
        </Typography>
        {Array.isArray(value) ? (
          <Typography>
            <SyntaxSpan content="[" />
            <div className="ml-4">
              {value.map((parameter, valueIndex) =>
                Object.entries(parameter).map(
                  ([parameterKey, parameterValue], index) => (
                    <div key={parameter}>
                      {index === 0 && <SyntaxSpan content="{" />}
                      <div className="flex space-x-2 ml-4">
                        <Typography className="text-red-500">
                          {`"${parameterKey}"`}
                          <SyntaxSpan content=":" />
                        </Typography>
                        <Typography className="text-blue-500">
                          {`"${parameterValue}"`}
                          {index === 0 && <SyntaxSpan content="," />}
                        </Typography>
                      </div>
                      {index === Object.entries(parameter).length - 1 && (
                        <>
                          <SyntaxSpan content="}" />
                          {valueIndex !== value.length - 1 && (
                            <SyntaxSpan content="," />
                          )}
                        </>
                      )}
                    </div>
                  )
                )
              )}
            </div>
            <SyntaxSpan content="]" />
          </Typography>
        ) : (
          <div className="text-blue-500">
            {`"${value}"`}
            <SyntaxSpan content="," />
          </div>
        )}
      </div>
    ))}
    <SyntaxSpan content="}" />
  </div>
);

export default FormatReference;
